const Locale = {
  TITLE: 'Visão Geral',
  botao: {
    confirmar: 'Confirmar',
    cancelar: 'Cancelar',
    salvar: 'Salvar',
  },
  mensagem: {
    exclusao: {
      titulo: 'Você realmente deseja excluir?',
      corpo: 'Ao excluir todos os dados serão perdidos.',
    },
    validacao: {
      obrigatorio: 'Campo é obrigatório',
      cpf: 'CPF é inválido',
      cnpj: 'CNPJ é inválido',
      email: 'E-mail é inválido',
      min: 'Obrigatório minimo 3 digitos',
    },
  },
  acao: {
    excluir: 'Excluir',
    editar: 'Editar',
    cadastrar: 'Cadastrar',
    importar: 'Importar planilha',
  },
  cadastro: {
    titulo: 'Cadastro de fornecedor',
    visualizar: 'Visualizar fornecedor',
    geral: 'Dados gerais',
    endereco: 'Endereço',
    contaBancaria: 'Conta bancária',
  },
  tabela: {
    nome: 'Nome',
    razaoSocial: 'Razão Social',
    cpfCnpj: 'CPF/CNPJ',
    telefone: 'Telefone principal',
  },
};

export default Locale;
